import { ApiClient, ApiError, NetworkError } from '@mall/shared';
import { env } from './env';

type Listener = (event:
  | { type: 'unauthorized' }
  | { type: 'rate-limited'; retryAfter: number | null }
  | { type: 'error'; error: ApiError | NetworkError }
) => void;

const listeners = new Set<Listener>();

export function subscribeApiEvents(listener: Listener): () => void {
  listeners.add(listener);
  return () => {
    listeners.delete(listener);
  };
}

function emit(event: Parameters<Listener>[0]): void {
  for (const listener of listeners) {
    try {
      listener(event);
    } catch (err) {
      console.error('[api-event-listener]', err);
    }
  }
}

export const apiClient = new ApiClient({
  baseUrl: env.apiBase,
  onUnauthorized: () => emit({ type: 'unauthorized' }),
  onRateLimited: (retryAfter) => emit({ type: 'rate-limited', retryAfter }),
  onError: (error) => emit({ type: 'error', error }),
});
